/* Utilities to manage pending inventory update batches in localStorage */

export const PENDING_PREFIX = 'inventory:pendingUpdate:';

export function getPendingKey(inventoryId) {
  return `${PENDING_PREFIX}${inventoryId}`;
}

export function readPending(inventoryId) {
  if (!inventoryId) return null;
  try {
    const raw = localStorage.getItem(getPendingKey(inventoryId));
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function savePending(inventoryId, pending) {
  if (!inventoryId) return;
  localStorage.setItem(getPendingKey(inventoryId), JSON.stringify(pending));
}

export function clearPending(inventoryId) {
  if (!inventoryId) return;
  localStorage.removeItem(getPendingKey(inventoryId));
}
